var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoCerrar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 14",
    style: {
      enableBackground: "new 0 0 14 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FE3B1F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,12.4H1.9c-0.2,0-0.3-0.2-0.3-0.3V1.9c0-0.2,0.2-0.3,0.3-0.3H7c0.4,0,0.8-0.4,0.8-0.8S7.4,0,7,0H1.9 C0.9,0,0,0.9,0,1.9v10.1C0,13.1,0.9,14,1.9,14H7c0.4,0,0.8-0.4,0.8-0.8S7.4,12.4,7,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,6.4l-3.4-3.4C10.2,2.9,10,2.8,9.8,2.8c-0.2,0-0.4,0.1-0.6,0.2C9.1,3.2,9,3.4,9,3.6C9,3.8,9.1,4,9.2,4.2 l2.1,2h-6C4.9,6.2,4.5,6.6,4.5,7s0.4,0.8,0.8,0.8h6l-2.1,2c-0.3,0.3-0.3,0.8,0,1.1c0.1,0.2,0.3,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2 l3.4-3.4C13.9,7.4,14,7.2,14,7C14,6.8,13.9,6.6,13.8,6.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCerrar);
export default __webpack_public_path__ + "static/media/icono_cerrar.6c074b5f20dd6b57bd5285d57bcd2539.svg";
export { ForwardRef as ReactComponent };